// extracted by mini-css-extract-plugin
export default {"user":"style_user__BpXiA","content":"style_content__-+C73","formContent":"style_formContent__h8GQd"};